import PropTypes from 'prop-types';
import React from 'react';

import { HeaderBgStyles } from '../../constants/HeaderBg';
import { jeCSS } from '../../lib/StyleUtils';

import './HeaderBg.scss';

class HeaderBg extends React.Component {
  static propTypes = {
    bgImgUrl: PropTypes.string,
    styleNames: PropTypes.arrayOf(PropTypes.oneOf([HeaderBgStyles.SMALL])),
    children: PropTypes.node,
  };

  renderBgImg = bgImgUrl => {
    if (bgImgUrl) {
      const bgStyle = { backgroundImage: `url(${bgImgUrl})` };
      return <div className='HeaderBg__img' style={bgStyle}></div>;
    }
    return <div className='HeaderBg__img HeaderBg__img--blueGradient'></div>;
  };

  render() {
    return (
      <div className={`${jeCSS('HeaderBg', this.props.styleNames)}`}>
        <div className='HeaderBg__imgContainer'>{this.renderBgImg(this.props.bgImgUrl)}</div>
        {this.props.children}
      </div>
    );
  }
}

export default HeaderBg;
